import 'babel-polyfill'; // extra polyfills we need for old browsers like IE       

import { attachQuestionEvents, SHOW_QUESTIONS_EVENT } from './questions';
import { attachResultsEvents } from './results';
import { setupGate } from './gate';
import { pageSetup } from './misc';

require('./contrib/modernizr-custom.js');

// promises polyfill for IE < 10, which we need to be able to use whatwg-fetch
var Promise = require('es6-promise').Promise; // eslint-disable-line no-unused-vars

var $ = require('jquery');
import './contrib/tooltipsy';


$(function() {

    setupGate();
    attachQuestionEvents();
    attachResultsEvents();

    pageSetup();

});



// WEBPACK FOOTER //
// ./src/main.js